import { creditApply } from '@/pages/CL/credit/interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonState {
  clPreCreditApply: creditApply | null;
  contranctLoanAmt: number | null;
}

const initialState: CommonState = {
  clPreCreditApply: null,
  contranctLoanAmt: null,
};

const clPreApprovalSlice = createSlice({
  name: 'pubSlice',
  initialState,
  reducers: {
    updateClPreApproCreditApply: (state, action: PayloadAction<creditApply>) => {
      state.clPreCreditApply = action.payload;
    },
    updateContranctLoanAmt: (state, action: PayloadAction<number>) => {
      state.contranctLoanAmt = action.payload;
    },
  },
});

const { updateClPreApproCreditApply, updateContranctLoanAmt } = clPreApprovalSlice.actions;

export { updateClPreApproCreditApply, updateContranctLoanAmt };

export default clPreApprovalSlice.reducer;
